import { render, staticRenderFns } from "./nfcreader.vue?vue&type=template&id=c2c990e0&"
import script from "./nfcreader.vue?vue&type=script&lang=js&"
export * from "./nfcreader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports